import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, PartyPopper, Palette, ArrowRight } from 'lucide-react';
import { SEASON } from '../../shared/season.js';

const items = [
  { Icon: Trophy, title: 'Sporta aktivitātes', color: 'from-primary-500 to-primary-600' },
  { Icon: PartyPopper, title: 'Šovi un izklaide', color: 'from-secondary-500 to-secondary-600' },
  { Icon: Palette, title: 'Radošās darbnīcas', color: 'from-accent-500 to-accent-600' },
//  { Icon: Music, title: 'Mūzika un ballīte', color: 'from-emerald-500 to-emerald-600' },
];

const WhatToExpect: React.FC = () => {
  return (
    <section id="what-to-expect" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-5xl font-bold gradient-text mb-3">Kas tevi sagaida</h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            {SEASON.registrationOpen
              ? 'Pilnu programmu publicēsim tuvāk nometnes datumam. Pagaidām saglabā vietu!'
              : 'Pilnu programmu publicēsim tuvāk nometnes datumam.'}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 max-w-4xl mx-auto">
          {items.map(({ Icon, title, color }, i) => (
            <motion.div
              key={title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              whileHover={{ y: -4 }}
              className="bg-white border border-gray-100 rounded-2xl p-5 md:p-6 text-center shadow-md hover:shadow-xl transition-shadow"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 rounded-2xl bg-gradient-to-br ${color} flex items-center justify-center shadow-lg`}>
                <Icon className="w-6 h-6 md:w-7 md:h-7 text-white" />
              </div>
              <h3 className="font-semibold text-gray-800 text-sm md:text-base">{title}</h3>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="flex justify-center mt-12"
        >
          <a
            href="#registration"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('registration')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 bg-gradient-to-r from-primary-500 to-secondary-500 text-white font-bold px-7 py-3 rounded-full shadow-lg hover:shadow-xl hover:scale-[1.02] transition-all"
          >
            {SEASON.registrationOpen ? 'Pieteikties' : 'Uzzināt vairāk'}
            <ArrowRight className="w-4 h-4" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default WhatToExpect;
